import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {ErrorEnum} from '../../../enums/error.enum';
import {EventTrackingService} from './event-tracking.service';
import {EventEnum} from '../../../enums/event.enum';

@Injectable({
    providedIn: 'root'
})
export class ErrorHandlerService {

    private behaviorSubject$ = new BehaviorSubject(null);

    currentError = this.behaviorSubject$.asObservable();

    constructor(private eventTracker: EventTrackingService) {}

    public setError(error: ErrorEnum|null) {
        this.behaviorSubject$.next(error);
    }

    public videoErrorAction(error: ErrorEnum|null, errorObject: any) {
        this.setError(error);

        if (error) {
            this.eventTracker.track(EventEnum.VideoError, {
                errorType: error, error: errorObject
            });
        }
    }
}
